import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView,
	Dimensions, FlatList, AsyncStorage, WebView, I18nManager, Platform } from "react-native";

import { format, parse } from 'date-fns'

import * as Font from 'expo-font';
import { payment } from "../config/payment"
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import Main from "../widgets/Main";
import * as firebase from "firebase";
import MainComponent from "../utilities/MainComponent";
import i18n from 'i18n-js';
import Axios from 'axios'

export default class PaymentScreen extends MainComponent {	
	
	state = {
		isLoading: false,
		store: {currency: ""},
		showFullMode 	: true,
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.showError = false
	
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
	
		this.state.paymentUrl = this.props.navigation.state.params.paymentUrl
		this.state.data	 	= this.props.navigation.state.params.data
		this.state.updates 	= this.props.navigation.state.params.updates

		this.state.paymentUrl = "https://www.google.com"

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		this.getDetails()
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);

		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
            this.setState({store: value})
            console.log("store data found")
            
        } catch (error) {
            console.log(error)
		}
	}

	backBtnPressed(){
		if(!this.state.isLoading)
			this.props.navigation.goBack(null)
	}
	
	// List View 

	render() {
		var that = this
		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		return (
			<View style={styles.container}>						

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t("checkout")}</Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
									onPress={() => { this.props.navigation.goBack(null) }} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>	
						<iframe style={{flex:1, marginTop: 50, backgroundColor: color.menuLight}} src={this.state.paymentUrl} height={this.state.height} width={this.state.width}/>
							<View style={{flex:1}}>
								<WebView originWhitelist={['*']}  
   
								useWebKit={true}
								thirdPartyCookiesEnabled={true}
								style={{flex:1, backgroundColor: 'transparent'}}
								javaScriptEnabled={true}
								domStorageEnabled={true}
								startInLoadingState={true}
								source={{ uri: this.state.paymentUrl }}													
						/>	 
						</View>			
						                     						
			</View>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});